import axios from 'axios';
import sendAccessToken from './hooks/sendAccessToken';
import refreshTokenWhenReceive from './hooks/refreshTokenWhenReceive';
import logoutWhenTokenExpires from './hooks/logoutWhenTokenExpires';

function setup({ store, router }) {
  axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  axios.defaults.headers.common.Accept = 'application/json';

  axios.interceptors.request.use(...sendAccessToken({ store }));
  axios.interceptors.response.use(...refreshTokenWhenReceive({ store }));
  axios.interceptors.response.use(...logoutWhenTokenExpires({ store, router }));
}

export default setup;
